import { Component, Input } from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { AnimalExternalNumber } from 'src/app/api/models';

@Component({
  selector: 'diana-select-external-numbers',
  standalone: false,
  templateUrl: './select-external-numbers.component.html',
  styleUrl: './select-external-numbers.component.scss',
})
export class SelectExternalNumbersComponent {

  @Input() formGroup!: FormGroup;
  @Input() externalNumbersAvailable: AnimalExternalNumber[] = [];
  @Input() formArrayExternalNumbers!: FormArray;
  @Input() index!: number;

  public generateDropdown(): AnimalExternalNumber[] {
    if (!this.formGroup || !this.formArrayExternalNumbers) {
      return this.externalNumbersAvailable;
    }
    const selectedExternalNumberIds: string[] = [];
    this.formArrayExternalNumbers.controls.forEach(selected => {
      const selectedNumberType = selected.get('numberType')?.value
      if (
        selectedNumberType?.id &&
        this.formGroup.get('numberType')?.value?.id !== selectedNumberType.id
      ) {
        selectedExternalNumberIds.push(selectedNumberType.id);
      }
    });

    return this.externalNumbersAvailable.filter(
      available => !selectedExternalNumberIds.includes(available.id)
    );
  }

  public typeChange(event: MatSelectChange): void {
    if (event.value.name === 'MicroChip') {
      this.formGroup.get('number')?.setValidators([Validators.maxLength(15), Validators.minLength(15)])
    }
  }
}